module.exports = __webpack_public_path__ + "static/media/address-active.e76ab4fe.svg";